// Global variabel for current database - settes av router guard
export let currentDatabase: string | null = null;

// Funksjon for å oppdatere database - kalles fra router guard
export function setCurrentDatabase (database: string | null) {
  currentDatabase = database;
}
